import React from "react";
import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import ClientDashboard from "../pages/client/dashboard/dashboard";
import ClientAppointments from "../pages/client/appointments/appointments";
import ClientAppointment from "../pages/client/appointment/appointment";
import FavoriteMediums from "../pages/client/favoritemediums";
import Topbar from "../components/topbar/topbar";
import Comingsoon from "../pages/comingsoon";
import MyProfile from "../pages/client/myprofile";
import ThankyouPopup from "../pages/client/appointment/premiumsessions/practitonerInfo/payment/thankyou";
import ShortCuts from "../pages/client/shortcuts";
import ClientVideo from "../pages/client/clientvideo";
import PayMyMedium from '../pages/paymymedium';
import AppointmentConfirm from "../pages/client/appointmentconfirm";
import GuestBooking from "../pages/guestbooking";
import VerifyEmail from "../pages/admin/calendar/verifyemail";
import GoOnDemandPractice from "../pages/medium/goOnDemandPractice/goOnDemandPractice";
// import GoOnDemandClientPractice from "../pages/client/goOnDemandPractice/goOnDemandPractice";
import GoOnDemandClientPractice from "../pages/client/goOnDemandPractice/goOnDemandPractice";
import ClientImmediateOnDemand from "../pages/client/immediateOnDemand/ClientImmediateOnDemand";
import RegistrationCompleted from "../pages/admin/registrationcompleted";
import Footer from "../pages/client/appointment/footer";
import BackFromClient from "../pages/client/backfillclient/goOnDemandPractice/goOnDemandPractice";
import CheckInService from "../pages/checkinservice";
import OnboardingBooking from "../pages/onboardingbooking";
import GiveGift from "../pages/gift/GiveGift";
import GiftCreated from "../pages/gift/GiftCreated";
import MyGifts from "../pages/gift/MyGifts";
import MyGift from "../pages/gift/MyGift";

// import Survey from "../pages/surveyform";
const LoggedInRoutes = ({ is_first_appointment }) => {
  let from = localStorage.getItem('registration-from');
  return (
    <Routes>
      <Route path="/" element={<Navigate to={localStorage.getItem('guest_id') ? `/guest-booking/${localStorage.getItem('guest_id')}` : from == "registration" ? '/registration-completed' : is_first_appointment ? "/shortcuts" : "/appointment"} />} />
      <Route path="/registration-completed" element={
        <div
          className="new-appointment new-appointment-listt"
        >
          <Topbar />
          <RegistrationCompleted />

        </div>
      } />
      {/* <Route path="/dashboard" element={<ClientDashboard />} /> */}
      <Route path="/appointments" element={<ClientAppointments />} />
      <Route path="/guest-booking/:id" element={<GuestBooking />} />
      {/* <Route path="/appointment-confirmation/:id" element={<AppointmentConfirm />} /> */}
      <Route path="/appointment-confirmation/:id" element={<AppointmentConfirm />} />
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route
        path="/appointment"
        element={
          <div
            className="new-appointment new-appointment-listt"
          >
            <Topbar />
            <ClientAppointment />
          </div>
        }
      />
      <Route path="/favorite-mediums" element={<FavoriteMediums />} />
      <Route path="/shortcuts" element={<ShortCuts />} />
      {/* VerySoul Gift — purchaser side */}
      <Route path="/give-a-gift" element={<GiveGift />} />
      <Route path="/gift-created" element={<GiftCreated />} />
      <Route path="/my-gifts" element={<MyGifts />} />
      <Route path="/my-gifts/:id" element={<MyGift />} />
      <Route path="/go-on-demand-practice" element={<GoOnDemandClientPractice />} />
      <Route path="/go-on-demand-immediate-session" element={<ClientImmediateOnDemand />} />
      <Route path="/feedback" element={<Comingsoon />} />
      <Route path="/my-profile" element={<MyProfile />} />
      <Route path="/thankyou" element={<ThankyouPopup />} />
      <Route path="/paymymedium/:id" element={<PayMyMedium />} />
      <Route path="/check-in-service" element={<CheckInService />} />
      {/* Clients who receive the medium-only link get an explanation, not a silent bounce. */}
      <Route path="/onboarding-booking/:mediumId" element={<OnboardingBooking />} />
      <Route path="intro-video" element={
        <div
          className="new-appointment new-appointment-listt"
        >
          <Topbar />
          <ClientVideo />
        </div>
      } />
      <Route path="/backfill-client" element={
        <div
          className=""
        >
          <Topbar /><BackFromClient /> </div>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default LoggedInRoutes;
